<template>
  <h1>InputButton</h1>

  <div class="row mt-2">
    <input-button :state="state" @click.prevent.stop="changeState">
      {{ state ? state : 'none' }} (cyclable)
    </input-button>
  </div>

  <div class="row mt-2">
    <input-button-toggle v-model="toggledDark" :light="false">
      {{ toggledDark ? 'toggled' : 'not toggled' }} (dark)
    </input-button-toggle>
  </div>

  <div class="row mt-2">
    <input-button-toggle v-model="toggledLight" :light="true">
      {{ toggledLight ? 'toggled' : 'not toggled' }} (light)
    </input-button-toggle>
  </div>
</template>

<script>
import DevComponentContainer from '../../../DevComponent/DevComponentContainer';
import InputButton from './InputButton';
import InputButtonToggle from './InputButtonToggle';

export default {
  name: 'InputButtonDev',
  components: { InputButton, InputButtonToggle },
  extends: DevComponentContainer,
  data() {
    const states = [null, 'active', 'active-light'];

    return {
      states,

      toggledDark: false,
      toggledLight: false,

      state: states[0],
      currentStateIndex: 0,
    };
  },
  methods: {
    increaseNumber(number) {
      number += 1;

      if (number >= this.states.length) {
        number = 0;
      }

      return number;
    },
    changeState() {
      this.currentStateIndex = this.increaseNumber(this.currentStateIndex);

      this.state = this.states[this.currentStateIndex];
    },
  },
};
</script>
